import React from 'react'
import ChannelName from './ChannelName';

import VideoCard from './VideoCard';



const Videos = ({ videos }) => {
  console.log(videos);

 
  return (
    <>
      <div className="container-fluid p-0">
        <div className="row m-0">
        {
          videos && videos.map((item, index)=>{
            return(
              <div className="col-12 col-sm-12 col-md-6 col-lg-3 mt-3 mb-2 p-0 p-sm-0 p-md-2  "  key={index} >
                    {item.id.videoId && <VideoCard video={item} />}
                    {item.id.channelId && <ChannelName channelDetail={item} />}
              </div>
            )
          })
        }
         
        </div>
      </div>
    </>
  )
}

export default Videos
